<template>
  <div>
    <div class="c_top_title">
      <i class="el-icon-back return_icon" @click="$router.go(-1)"></i>
      {{$t('bank_card.check_order')}}
    </div>

    <div class="t_h1">
      <div class="t_h1_box">
        <el-form class="zdy_form" label-position="top">
          <!-- <el-form-item>
            <el-select v-model="card_array" :placeholder="$t('bank_card.card_array')">
              <el-option v-for="item in card_array_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-select v-model="card_level" :placeholder="$t('bank_card.card_level')">
              <el-option v-for="item in card_level_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="card_type" :placeholder="$t('bank_card.Card_class')">
              <el-option v-for="item in card_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form>
          <el-form-item class="btn_box">
            <el-button class="reset_btn border_set_color" size="medium" @click="reset_btn">{{$t('main.text329')}}</el-button>
            <el-button class="apply_btn" size="medium" @click="apply_btn">{{$t('main.text330')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="transaction_h">
      <div class="t_h2">
        <!-- <div class="t_h2_box">
          <div>
            <div class="t_h2_txt1">
              <i class="el-icon-back return_icon" @click="$router.go(-1)"></i>
              {{$t('bank_card.check_order')}}
            </div>
          </div>
        </div> -->
        <div class="t_h2_table zdy_tab_header cards_table">
          <el-table :data="tableData" stripe style="width: 100%">

            <el-table-column
              label="#"
              type="index"
              width="50">
            </el-table-column>

            <el-table-column :label="$t('bank_card.create_time')">
              <span slot-scope="props">
                <div>{{ overall_time2(props.row.create_time) }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.order_id')">
              <span slot-scope="props">
                <div>{{ props.row.order_id }}</div>
              </span>
            </el-table-column>

            <!-- <el-table-column :label="$t('bank_card.card_array')" min-width="100">
              <span slot-scope="props">
                {{ props.row.card_array_name||"-" }}
              </span>
            </el-table-column> -->

            <el-table-column :label="$t('bank_card.card_level')" min-width="100">
              <span slot-scope="props">
                {{ props.row.card_level_name||"-" }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Card_class')" min-width="100">
              <span slot-scope="props">
                {{ props.row.card_type_name||"-" }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.amount_num')">
              <span slot-scope="props">
                <div>{{ props.row.amount }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Allocated_quantity')" min-width="100">
              <span slot-scope="props">
                <div>{{ props.row.assign_amount }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.unallocated_quantity')" min-width="100">
              <span slot-scope="props">
                <div>{{ props.row.not_assign_amount }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text620')" min-width="100">
              <span slot-scope="props">
                <div>{{ props.row.remark }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.state')">
              <!-- "status": 1, 状态 1待定(待接受) 2已接受(安排中) 3已取消 4部分分配 5完成分配  -->
              <span slot-scope="props">
                <span v-if="props.row.status==1">{{$t('bank_card.status_1')}}</span>
                <span v-else-if="props.row.status==2">{{$t('bank_card.status_2')}}</span>
                <span v-else-if="props.row.status==3">{{$t('bank_card.status_3')}}</span>
                <span v-else-if="props.row.status==4">{{$t('bank_card.status_4')}}</span>
                <span v-else-if="props.row.status==5">{{$t('bank_card.status_5')}}</span>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.status_remark')">
              <span slot-scope="props">
                <div>{{ props.row.status_remark }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.operate')">
              <span slot-scope="props">
                <img class="icon_width" @click="to_info(props.row.order_id)" :src="require('../../assets/img/info_icon.png')" alt="">
              </span>
            </el-table-column>

          </el-table>

          <el-pagination
            v-if="tableData.length > 0"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="limit"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :total="total"
            @current-change="current_change"
          ></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { orderList,getConfigData } from "@/api/api";

export default {
  data() {
    return {
      currentPage: 1,
      page: 0, //分页 从 1 开始
      limit: 10, //每页条数
      total: 0, //一共多少条
      tableData: [],
      order_id:this.$route.query.order_id,

      card_array_list:[],
      card_level_list:[],
      card_type_list:[],
      card_array:'',
      card_level:'',
      card_type:'',

    };
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  mounted() {
    sessionStorage.setItem("top_title_name", ' ');
    this.get_list();
    this.get_config_data();
  },
  methods: {
    async get_list() {
      const res = await orderList({
        page:this.page,
        limit:this.limit,
        tx_id:this.order_id,
        card_array:this.card_array,
        card_level:this.card_level,
        card_category:this.card_type,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage('error',res.data.msg);
      }
      // console.log(res.data.data);
      this.total = res.data.data.count;
      this.tableData = res.data.data.list;
    },
    async get_config_data(){
      const res = await getConfigData();
      if (res.data.code !== 200) {
        return this.message.ismessage('error',res.data.msg);
      }
      this.card_array_list=res.data.data.card_array;
      this.card_level_list=res.data.data.card_level;
      this.card_type_list=res.data.data.card_type;
    },
    current_change(v){
      this.page=v - 1;
      this.limit=10;
      this.get_list();
    },
    to_info(id){
      this.$router.push({path:'/card_record',query:{order_id:id}});
      // console.log(id);
    },
    reset_btn(){
      this.card_array='';
      this.card_level='';
      this.card_type='';
      this.page=0;
      this.limit=10;
      this.currentPage=1;
      this.get_list();
    },
    apply_btn(){
      this.page=0;
      this.limit=10;
      this.currentPage=1;
      this.get_list();
    },

  },

};
</script>

<style scoped>
.t_h1_top{
  margin-top: 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box{
  background: #314B69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item{
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select{
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child{
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}
.zdy_form >>> .el-input__inner{
  background: #223C58;
  border: none;
  border-radius: 8px;
  color: #fff;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus{
  color: #DEB981;
  border-color: #DEB981;
  background: transparent;
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  border-radius: 4px;
}
.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus{
  min-width: 120px;
  border-color: #F1C788;
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182A;
  margin-left: 20px;
}
.zdy_form .btn_box{
  width: auto;
}
.t_h2_box{
  display: flex;
  justify-content: space-between;
  /* margin-top: 30px; */
  align-items: center;
}
.t_h2_txt1{
  font-style: normal;
  font-size: 14px;
  line-height: 26px;
}
.t_h2_txt2{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus{
  color: #DEB981;
  border-color: #DEB981;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  /* min-width: 120px; */
  background: transparent;
}
.icon_width{
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.color_red{
  color: #F35F65;
}
.zdy_tab_header >>> .el-table tr th:last-child, .zdy_tab_header >>> .el-table__body tr td:last-child{
  padding-left: 0 !important;
}
.btn_icon{
  width: 19px;
  vertical-align: middle;
  margin-right: 12px;
}
.tab_btn1{
  height: 32px;
  border: 1px solid #DEB981;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #DEB981;
  background: transparent;
  margin-top: 5px;
}
.tab_btn2{
  height: 32px;
  border: 1px solid #FF4646;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #FF4646;
  background: transparent;
  margin-top: 10px;
}
.top_text{
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  margin-bottom: 20px;
  word-break: break-word;
}
.dlg_form >>> .el-textarea__inner {
  background: #223C58;
  border-color: #223C58;
  color: #fff;
  height: 100px;
}

.confirm_btn_bgc,
.confirm_btn_bgc:hover,
.confirm_btn_bgc:focus,
.confirm_btn_bgc:active{
  background: #F35F65;
  border-color: #F35F65;
  color: #fff;
}
/* ---08-16 新增 --- */
.top_text2{
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #FFFFFF;
  margin-bottom: 10px;
  word-break: break-word;
}
.info_1{
  display: flex;
  border-bottom: 1px solid #314B69;
  box-sizing: border-box;
  padding: 20px 0;
}
.info_1_left{
  width: 60%;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
}
.info_1_right{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.top_text3{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.amount_box{
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px solid #223C58;
}
.top_text4{
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  margin-bottom: 8px;
}
.top_text5{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.top_text5_2:nth-child(8){
  padding-top: 10px;
}
.top_text5_2{
  padding-top: 2px;
}
/* -- 输入下拉 选择币种 */
.zdy_input >>> .el-input__inner{
  /* width: 224px; */
  height: 68px;
  background: #223C58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 8px 0px 0px 8px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
}
.zdy_input >>> .el-input{
  width: 100%;
}
.zdy_input{
  display: flex;
}
.zdy_form >>> .el-form-item__label{
  line-height: inherit;
  padding: 0;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}
.type_box{
  /* width: 154px; */
  width: 170px;
  height: 68px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #041728;
}
.type_box1{
  display: flex;
  align-items: center;
  cursor: pointer;
}
.type_box1 img{
  width: 26px;
  vertical-align: middle;
  margin-right: 8px;
}
.type_box2{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}
.type_box3{
  color: rgba(255, 255, 255, 0.8);
}
.bz_list{
  box-sizing: border-box;
  padding: 8px;
}
.bz_list1{
  margin-bottom: 10px;
}
.bz_list .bz_list1:last-child{
  margin-bottom: 0;
}
.inp_btm_tit{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 12px;
}
/* ----over---- */
.box_margin{
  box-sizing: border-box;
  padding: 8px 0 12px;
}
.top_text6{
  margin-top: 25px;
  margin-bottom: 8px;
}
.top_text7{
  /* padding: 18px 12px 20px;
  background: #041728; */
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
}
.div_num{
  flex: 1;
  background: #223C58;
  text-align: right;
  height: 68px;
  line-height: 68px;
  box-sizing: border-box;
  padding-right: 15px;
  border-radius: 0 8px 8px 0;
}
.top_text7_2{
  padding: 18px 12px 20px;
  background: #041728;
  border-radius: 0 8px 8px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
  min-width: 120px;
  text-align: center;
}
.top_text8{
  display: flex;
  margin-top: 12px;
}
.top_text8>div{
  width: 50%;
}
.top_text9{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
  opacity: 0.6;
}
.top_text10{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
}
.warning_red{
  background: #FEDFE0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.warning_yellow{
  background: #E8DAC8;
}
.warning_red_icon i{
  color: #F35F65;
  font-size: 25px;
  margin-right: 12px;
}
.warning_red_text{
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #F35F65;
}
.warning_yellow_icon i,
.warning_yellow_text{
  color: #B28247;
}
.top_up_link{
  color: #041728;
  text-decoration: underline;
}
.yellow{
  color: #d9b680;
  cursor: pointer;
}



</style>

<style>
.cards_table .row_2_bgc,
.cards_table .row_2_bgc .el-table__cell{
  background: #172C43 !important;
}
.cards_table .row_2_bgc:hover{
  background: #172C43 !important;
}
.cards_table .el-table--striped .el-table__body .row_2_bgc ,
.cards_table .el-table--striped .el-table__body .row_2_bgc td.el-table__cell{
  background: #172C43 !important;
}
/* ------ */
.bz_pop{
  color: #fff;
  font-size: 15px;
  background: #041E35;
  box-shadow: 0px 0px 4px #4f78a9;
  /* border-radius: 16px; */
  border: none;
  box-sizing: border-box;
  transform: translateY(-10px);
}
.bz_pop .popper__arrow {
  display: none;
}
.btm_text{
  line-height: initial;
  padding-top: 5px;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}

.c_top_title{
  font-size: 16px;
  margin-bottom: 20px;
}
.num_item{
  box-sizing: border-box;
  padding: 20px 30px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #314b69;
}
.num_item div{
  margin-bottom: 7px;
}
.num_item div:last-child{
  margin-bottom: 0;
}
.c_top_num_box .num_item{
  margin-right: 20px;
}
.c_top_num_box .num_item:last-child{
  margin-right: 0;
}
.return_icon{
  cursor: pointer;
  margin-right: 10px;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
  .t_h2_box {
    display: block;
    margin-top: 0;
    align-items: left;
  }
  .t_h1_top {
    margin-top: 0;
  }
  .t_h2_txt1 {
    margin-bottom: 10px;
    margin-top: 40px;
  }
  .num_item{
    width: 100%;
    margin-right: 0;
    margin-bottom: 15px;
  }

}
</style>
